module.exports = __webpack_public_path__ + "img/urkunden.05731b1c.png";